import type { FeatureFlag } from '@risksmart-app/modules/src/index';

/**
 * Per-entity Smart Copy descriptor for Indicators — the single source of truth
 * for the Indicator tab's gate + tooltip wording. Mirrors
 * `controlTestSmartCopy.ts`.
 *
 * - `flagKey` — per-org feature flag (`Meta.features`), read via
 *   `useIsFeatureFlagEnabled`; typed against the feature-flag registry.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase).
 *
 * `eventLabel` is intentionally omitted — Amplitude wiring lands in later work.
 */
export const INDICATOR_SMART_COPY = {
  flagKey: 'smart_copy_indicator' satisfies FeatureFlag,
  entityNoun: 'indicator',
} as const;
